/**
 * @license Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { RegexUtils } from "../Utils/RegexUtils";
var ValidationPatterns = /** @class */ (function () {
    function ValidationPatterns() {
    }
    ValidationPatterns.get = function (validationType) {
        switch (validationType) {
            case "email":
                return ValidationPatterns.emailV2;
            case "phone":
                return ValidationPatterns.phoneNumberV2;
            case "url":
                return ValidationPatterns.urlV2;
            case "custom":
            case "no_validation":
                return null;
        }
    };
    ValidationPatterns.parse = function (validationRegex) {
        var regexEqual = function (targetRegex) {
            return RegexUtils.regexEqual(validationRegex, targetRegex);
        };
        if (regexEqual(ValidationPatterns.email) || regexEqual(ValidationPatterns.emailV2)) {
            return "email";
        }
        if (regexEqual(ValidationPatterns.phoneNumber) || regexEqual(ValidationPatterns.phoneNumberV2) || regexEqual(ValidationPatterns.phoneNumberWithOrWithoutCountryCode)) {
            return "phone";
        }
        if (regexEqual(ValidationPatterns.url) || regexEqual(ValidationPatterns.urlV2)) {
            return "url";
        }
        if (validationRegex === null) {
            return "no_validation";
        }
        return "custom";
    };
    // The first group - letters and numbers, including an underscore and different languages. The second group - optional multiple dots, pluses or dashes in the middle.
    // After the at sign, we have 2 options: either a domain and a top-level domain or a valid IP address.
    // The first group in that set - letters and numbers, including an underscore and different languages. The second group is for a top-level domain, includes a dot and followed by letters.
    // The next group is for a second top-level domain (ex: "name@domain.com.net")
    // email: to be used only for backwards compatibility (reading old forms)
    ValidationPatterns.email = /[^@\s\\"<>)(\[\]:;,.]+(([.]{1}[^@\s\\"<>)(\[\]:;,.]+)+?|)@([^@\s\\"<>)(\[\]\+:;,\.-]+(((\.|\+|-|--)[^@\s\\"<>)(\[\]+:;,.-]+)+?|)([.][^0-9@\s\\"<>)(\[\]+:;,.-]+)+?)/;
    // emailV2: to be used for new forms
    ValidationPatterns.emailV2 = /[^@\s\\"<>\)\(\[\]:;,.]+(([.]{1}[^@\s\\"<>\)\(\[\]:;,.]+)+?|)@([^@\s\\"<>\)\(\[\]\+:;,\.\-]+(((\.|\+|-|--)[^@\s\\"<>\)\(\[\]+:;,.\-]+)+?|)([.][^0-9@\s\\"<>\)\(\[\]+:;,.\-]+)+?)/;
    // First group - http or https, once or zero times - protocol
    // Second group - www, once or zero times
    // Next group - any letter, any digit or @ : % . _ + ~ # =, between 2 and 256 times - domain
    // Next group - . followed by beetwen 2 and 6 letters - top level domain
    // /b - word boundry
    // Last group - any letter, any digit, @ : % _ + . ~ # ? & / = , any number of times - path, query params, fragment
    // url: to be used only for backwards compatibility (reading old forms)
    ValidationPatterns.url = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    // urlV2: to be used for new forms
    ValidationPatterns.urlV2 = /(http(s)?:\/\/.)?(www\.)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/;
    // international prefix with 1-4 digits and optional brackets - either starting with + or (00|011|010)
    // digits with optional -, brackets or whitespaces around it, 3-16 times
    // phoneNumber: to be used only for backwards compatibility (reading old forms)
    ValidationPatterns.phoneNumber = /^(\+[(]?[0-9]{1,4}|[(]?00[0-9]{0,2}|[(]?011[0-9]?|[(]?010[0-9]?)[)]?([ \-()]*[0-9][ \-()]*){3,16}$/;
    // phoneNumberV2: to be used for new forms
    ValidationPatterns.phoneNumberV2 = /(\+[\(]?[0-9]{1,4}|[\(]?00[0-9]{0,2}|[\(]?011[0-9]?|[\(]?010[0-9]?)[\)]?([ \-\(\)]*[0-9][ \-\(\)]*){3,16}/;
    // phoneNumberWithoutCountryCode: to be used in case countryCode is provided
    ValidationPatterns.phoneNumberWithOrWithoutCountryCode = /(\+[\(]?[0-9]{1,4}|[\(]?00[0-9]{0,2}|[\(]?011[0-9]?|[\(]?010[0-9]?)[\)]?([ \-\(\)]*[0-9][ \-\(\)]*){3,16}|([ \-\(\)]*[0-9][ \-\(\)]*){3,16}/;
    return ValidationPatterns;
}());
export { ValidationPatterns };
